export const awsConfig = {
  region: 'us-east-1',
  userPoolId: 'us-east-1_JcH4gNoqI',
  userPoolWebClientId: '6vipoq6s4seif0r0n4rhsu13gr',
  // clientSecret usunięty - teraz bezpiecznie przechowywany w Lambda
  // Zobacz: lambda-auth-proxy/AUTH-PROXY.md
  authProxyUrl: process.env.REACT_APP_AUTH_PROXY_URL || 'https://s3y538x7eg.execute-api.us-east-1.amazonaws.com',
  oauth: {
    domain: 'login.bergregions.pl',
    scope: ['openid','email','profile'],
    redirectSignIn: window.location.origin + '/callback',
    redirectSignOut: window.location.origin,
    responseType: 'code',
  }
};
